
import { Button } from "@/components/ui/button";
import { Loader2, RefreshCw } from "lucide-react";

type LocationFormActionsProps = {
  isDetecting: boolean;
  isSubmitting: boolean;
  detectLocation: () => Promise<void>;
};

const LocationFormActions = ({ 
  isDetecting, 
  isSubmitting, 
  detectLocation 
}: LocationFormActionsProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <Button 
        type="button" 
        variant="outline" 
        onClick={detectLocation} 
        disabled={isDetecting || isSubmitting}
      >
        {isDetecting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Detecting...
          </>
        ) : (
          <>
            <RefreshCw className="mr-2 h-4 w-4" />
            Auto-Detect Location
          </>
        )}
      </Button>

      <Button type="submit" disabled={isSubmitting || isDetecting}>
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Saving...
          </>
        ) : (
          "Save Location"
        )}
      </Button>
    </div>
  );
};

export default LocationFormActions;
